<template>
  <div id="app">
    <div class="sticky-nav px-4">
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <h1 class="h2">Chauffeurs</h1>
      </div>

      <div class="dropdown">
        <button class="btn btn-dark" type="button" id="dropdownMenuButton" v-on:click="modalToevoegenChauffeur()">
          <i class="fas fa-plus"></i> Chauffeur toevoegen
        </button>
      </div>
    </div>

    <br /><br />

    <vue-good-table
      v-if="chauffeurs && chauffeurs.length"
      class="mb-3 px-4"
      @on-selected-rows-change="selectionChanged"
      @on-cell-click="onRowClick"
      :columns="chauffeurColumns"
      :rows="chauffeurs"
      :pagination-options="{
        enabled: true,
        mode: 'pages',
        perPage: 100,
        position: 'bottom',
        perPageDropdown: [25, 50, 100],
        setCurrentPage: 1,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Rows per page',
        ofLabel: 'of',
        pageLabel: 'page', // for 'pages' mode
        allLabel: 'All',
        dropdownAllowAll: true,
      }"
      :selectOptions="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
      }"
    />

    <!-- Modal -->
    <div
      class="modal fade"
      id="chauffeurModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ editModalTitle }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="chauffeur">
              <label>Naam</label><input type="text" class="form-control" v-model="chauffeur.naam" placeholder="Naam" />
              <label>Voornaam</label
              ><input type="text" class="form-control" v-model="chauffeur.voornaam" placeholder="Voornaam" />
              <label>Telefoon</label
              ><input type="text" class="form-control" v-model="chauffeur.telefoon" placeholder="Telefoon" />
              <label>E-mail</label
              ><input type="text" class="form-control" v-model="chauffeur.email" placeholder="E-mail" />
              <label>Handtekening</label>
              <img v-if="chauffeur.handtekening" :src="chauffeur.handtekening" class="signature-control" />
              <button type="button" class="btn btn-secondary float-right mt-2 mr-2" v-on:click="sign()">
                {{ chauffeur.handtekening ? "Handtekening wijzigen" : "Handtekening toevoegen" }}
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="checkNewChauffeur === false"
              type="button"
              class="btn btn-danger"
              v-on:click="deleteChauffeur()"
            >
              Verwijderen
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Sluiten
            </button>
            <button v-if="checkNewChauffeur" type="button" class="btn btn-primary" v-on:click="createChauffeur()">
              Opslaan
            </button>
            <button v-else type="button" class="btn btn-primary" v-on:click="updateChauffeur()">
              Aanpassen
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="signModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Tekenen</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="signatureContainer">
              <VPerfectSignature style="position: relative" :stroke-options="strokeOptions" ref="signaturePad" />
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" v-on:click="clear()">
              Opnieuw
            </button>
            <button type="button" class="btn btn-primary" v-on:click="saveSignature()">
              Opslaan
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "bootstrap";
import axios from "axios";

import VPerfectSignature from "v-perfect-signature";

export default {
  name: "app",
  components: {
    VPerfectSignature,
  },
  data() {
    return {
      checkNewChauffeur: false,
      importType: "-1",
      importCategory: "-1",
      types: [
        {
          name: "Chauffeurs",
        },
        {
          name: "Contacten",
        },
        {
          name: "Leveradressen",
        },
      ],
      editModalTitle: "",
      chauffeur: {},
      chauffeurs: {
        attributes: [],
        related: [],
      },
      chauffeurColumns: [
        { label: "Naam", field: "naam", filterOptions: { enabled: true } },
        {
          label: "Voornaam",
          field: "voornaam",
          filterOptions: { enabled: true },
        },
        {
          label: "Telefoon",
          field: "telefoon",
          filterOptions: { enabled: true },
        },
      ],
      attrPos: 0,
      showSignaturePad: false,
      strokeOptions: {
        size: 4,
        thinning: 0,
        smoothing: 0.5,
        streamline: 0.5,
      },
    };
  },
  mounted() {
    this.getChauffeurs();
  },
  watch: {
    showSignaturePad(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.signaturePad.fromDataURL(this.chauffeur.handtekening);
          this.$refs.signaturePad.resizeCanvas(true);
        }, 300);
      }
    },
  },
  methods: {
    grootteFn(rowObj) {
      return rowObj.grootte + " m³";
    },
    sign() {
      $("#chauffeurModal").modal("hide");
      $("#signModal").modal("show");
      this.showSignaturePad = true;
    },
    saveSignature() {
      const dataURL = this.$refs.signaturePad.toDataURL();
      axios
        .put("https://hofman.weblion.be/api/handtekening/", {
          chauffeur: this.chauffeur,
          handtekening: dataURL,
        })
        .then(async (response) => {
          console.log(response.data);
          await this.getChauffeurs();
          this.chauffeur = this.chauffeurs.find((c) => c.id === this.chauffeur.id);
          $("#chauffeurModal").modal("show");
          $("#signModal").modal("hide");
        });
    },
    getChauffeurs() {
      return new Promise((resolve, reject) => {
        axios
          .get("https://hofman.weblion.be/api/chauffeurs/")
          .then((response) => {
            this.chauffeurs = response.data;
            console.log(this.chauffeurs);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteChauffeur() {
      axios
        .delete("https://hofman.weblion.be/api/chauffeurs/", {
          data: {
            chauffeur_id: this.chauffeur.id,
          },
        })
        .then((response) => {
          this.getChauffeurs();
          $("#chauffeurModal").modal("hide");
          console.log(response.data);
        });
    },
    updateChauffeur() {
      axios
        .put("https://hofman.weblion.be/api/chauffeurs/", {
          chauffeur: this.chauffeur,
        })
        .then((response) => {
          this.getChauffeurs();
          $("#chauffeurModal").modal("hide");
          console.log(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    clear() {
      this.$refs.signaturePad.clear();
    },
    createChauffeur() {
      axios
        .post("https://hofman.weblion.be/api/chauffeurs/", {
          chauffeur: this.chauffeur,
        })
        .then((response) => {
          this.getChauffeurs();
          $("#chauffeurModal").modal("hide");
          console.log(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    modalToevoegenChauffeur() {
      this.chauffeur = {};
      this.editModalTitle = "Chauffeur toevoegen";

      this.checkNewChauffeur = true;

      $("#chauffeurModal").modal("show");
    },
    onRowClick(table) {
      this.editModalTitle = "Chauffeur aanpassen";
      this.chauffeur = table.row;

      this.checkNewChauffeur = false;

      $("#chauffeurModal").modal("show");
    },
    selectionChanged(table) {
      this.chauffeursSelected = table.selectedRows;
    },
    modalAanpassenChauffeur() {
      this.checkNewChauffeur = false;
      this.editModalTitle = "Chauffeur aanpassen";

      $("#chauffeurModal").modal("show");
    },
    sChauffeur() {
      axios
        .post("https://hofman.weblion.be/api/chauffeurs/update.php", {
          chauffeur: this.chauffeur,
        })
        .then((res) => {
          console.log(res);
          this.getChauffeurs();
        })
        .then(function() {
          $("#chauffeurModal").modal("hide");
        });
    },
  },
};
</script>

<style>
button {
  margin-right: 10px;
}
.table thead th {
  text-align: left !important;
}
.pager ul {
  list-style-type: none;
}
.pager ul li {
  display: inline-block;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 5px;
  width: 40px;
  text-align: center;
  margin: 2px;
}
.modal input,
.modal select {
  margin-bottom: 5px;
}
.modal-body label {
  display: inline-block;
  width: 32%;
}

.modal-body .form-control {
  display: inline-block;
  width: 68%;
}

.modal-body .signature-control {
  display: inline-block;
  width: 68%;
  height: 60px;
}

.modal-body select {
  text-indent: 5px;
}

#exampleModal input {
  display: block;
  width: 100%;
}

#importModal .modal-body label {
  width: auto;
}

#importModal input,
#importModal select {
  display: inline-block;
  width: 49%;
  margin-bottom: 5px;
}

#importModal .match-wrapper,
#importModal form {
  width: 100%;
}
#importModal select {
  margin-left: 1%;
}

#importModal .fullw {
  display: block;
  width: 100%;
  border-radius: 4px;
}

#importModal .fullw select {
  margin: 0;
}

#importModal .fullw input {
  display: block;
  width: 100%;
  margin: 0;
}

.dropdown {
  display: inline-block;
}
.dropdown-item:hover {
  cursor: pointer !important;
}
.dropdown-item i {
  margin-right: 3px;
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 550px;
    margin: 1.75rem auto;
  }
}
.groupedState {
  display: inline-block;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  margin-left: 25%;
}

#autoGroupModal table tr td {
  padding: 2px 10px;
}

#autoGroupModal .modal-title span {
  color: #777;
  font-size: 14px;
  margin-left: 10px;
}

#autoGroupModal input {
  width: 100%;
}

#autoGroupModal .form-check-input {
  width: auto;
  position: relative;
  margin: 0;
  vertical-align: 2px;
}

.ck.ck-editor {
  display: inline-block !important;
  width: 68% !important;
  margin-bottom: 5px !important;
}

.sticky-nav {
  position: fixed;
  height: 150px;
  top: 50;
  z-index: 2;
  background: white;
  padding-top: 10px;
  width: 100%;
  margin-top: -10px;
}

#chauffeurModal textarea {
  height: 100px;
}

.vgt-wrap {
  margin-top: 120px;
}

label {
  vertical-align: top;
}

[data-g="1"] {
  background: #8cc040;
}

[data-g="0"] {
  background: red;
}
.btn-danger {
  margin-right: 210px;
}
</style>
